module.exports = __webpack_public_path__ + "assets/checked.4eda1584.svg";